export default __webpack_public_path__ + "static/03.01-3b0c7f86246bc9c6fbca17fa54ff98a0.png";